import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NanorepPanelComponent } from './nanorep-panel.component';
import { ScriptLoaderService } from './script-loader.service';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { NanorepService } from './nanorep.service';
import { NanorepAnswerComponent } from './nanorep-answer/nanorep-answer.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    SvgIconModule
  ],
  providers: [
    ScriptLoaderService,
    NanorepService
  ],
  declarations: [
    NanorepPanelComponent,
    NanorepAnswerComponent
  ],
  exports: [
    NanorepPanelComponent
  ]
})
export class NanorepPanelModule {}
